<template lang='pug'>
.items-box(:class='[`--${this.position}`]', :style='[hasScroll ? { overflowY: "auto" } : ""]')
    .item(v-for='(option, i) of list', :key='i', @click='click(option)')
        .option-icon.mdi(v-if='option && props.icon && option[props.icon]' :class='option[props.icon]')
        span {{ option[props.label] }}
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
            required: true,
        },
        position: {
            type: String,
            default: 'right',
            validator: function (value) {
                return ['left', 'right', 'bottom', 'top'].includes(value);
            },
        },
        hasScroll: {
            type: Boolean,
            default: false,
        },
        props: {
            type: Object,
            default: () => ({
                id: 'id',
                icon: 'icon',
                label: 'label',
            }),
        },
    },
    data() {
        return {
            hasCreated: false,
        };
    },
    created() {
        document.addEventListener('click', this.clickOutsideHandler, true);
    },
    mounted() {
        this.hasCreated = true;
    },
    methods: {
        clickOutsideHandler(e) {
            if (!this.hasCreated) {
                return;
            }
            if (!this.$el.parentNode?.contains(e.target)) {
                this.$emit('close');
            }
        },
        click(option) {
            this.$emit('click', option);
        },
    },

    beforeDestroy() {
        document.removeEventListener('click', this.clickOutsideHandler);
    },
};
</script>

<style scoped>
.items-box {
    min-width: 300px;
    max-height: 300px;
    color: #fff;
    border-radius: 6px;
    position: absolute;
    background-color: var(--primary-white);
    border: 1px solid var(--primary-green);
    z-index: 1;
}

.items-box::-webkit-scrollbar {
    width: 8px;
}

.items-box::-webkit-scrollbar-track {
    background-color: var(--primary-smoke);
}

.items-box::-webkit-scrollbar-thumb {
    border-radius: 100px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.items-box.--left {
    left: -1;
    right: 0;
}

.items-box.--right {
    left: 0;
    right: 0;
}

.items-box .item {
    color: var(--primary-green);
    padding-left: 1em;
    cursor: pointer;
    user-select: none;
    padding: 0px 15px;
}

.items-box .option-icon {
    margin-right: 3px;
    color: var(--primary-green);
}

.items-box .item:hover {
    background-color: var(--primary-light-green);
    color: var(--primary-white);
}

.item {
    display: flex;
}
</style>
